export default function KoobAuthCard({
  logo,
  title,
  subtitle,
  backgroundImage,
  children,
}: {
  logo: string;
  title?: string;
  subtitle?: string;
  backgroundImage?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      {backgroundImage && (
        <div
          className="absolute inset-0 bg-cover bg-center blur-sm scale-105 brightness-75"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}

      {!backgroundImage && <div className="absolute inset-0 bg-[#F5F5F5]" />}

      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg p-10 w-full max-w-md relative z-raised">
        <div className="flex justify-center mb-8">
          <img src={logo} alt="KOOB" className="h-8" />
        </div>

        {title && (
          <h1 className="text-xl font-bold text-k-h text-center mb-1">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="text-sm text-k-p text-center mb-6">{subtitle}</p>
        )}

        {children}
      </div>
    </div>
  );
}
